module.exports = __webpack_public_path__ + "main/assets/public/player-media-session/playing-96.d7ab01897d24ff89.jpg";